import React, { useState } from "react";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  Box,
  Typography,
  FormControl,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useSearchParams } from "react-router-dom";

const Filter = ({ filters, filterState, setFilterState, setSearchFilters }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const handleFilterClick = async () => {
    setSearchFilters(filterState);
  };

  return (
    <Box
      component="section"
      sx={{
        overflow: "auto",
        maxHeight: "60vh",
        width: { xl: "10em", lg: "10em", md: "95%", sm: "95%" },
        minWidth: { lg: "20rem" },
        maxWidth: "100vw",
        position: { xl: "fixed", lg: "fixed", md: "sticky", sm: "sticky" },
        mt: 5,
        pb: 5,
        backgroundColor: "white",
        "&::-webkit-scrollbar": {
          width: "0.2em",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "grey",
          width: "1px",
        },
        borderTop: 3,
        borderBottom: 3,
        borderRight: 3,
        boxShadow: " 5px -2px 19px 0px rgba(242,242,242,1)",
        borderTopRightRadius: "10px",
        borderBottomRightRadius: "10px",
        borderColor: "transparent",
      }}
    >
      <Box
        sx={{
          position: "sticky",
          top: 0,
          display: "flex",
          width: "100%",
          justifyContent: "center",
          pt: 3,
          pb: 1,
          backgroundColor: "white",
          zIndex: 10000,
          boxShadow: "3px 0px 6px 0.5px rgba(235,240,255,1)",
        }}
      >
        <Typography variant="h4">Φίλτρα</Typography>
      </Box>
      <Box
        component="section"
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <FormControl>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            {filters.map((filter, index) => (
              <Accordion
                key={index}
                sx={{
                  border: "none",
                  boxShadow: " 2px 0px 16px -7px rgba(204,204,204,1)",
                  display:
                    index == 1 && searchParams.get("tab") == "unpaid"
                      ? "none"
                      : "block",
                }}
              >
                <AccordionSummary
                  key={index}
                  expandIcon={<ArrowDropDownIcon />}
                >
                  <Typography key={index} variant="h5">
                    {filter.title}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  key={index}
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 3,
                  }}
                >
                  {filter.details}
                </AccordionDetails>
              </Accordion>
            ))}

            <Box
              sx={{
                display: "flex",
                mt: 10,
                gap: 2,
                width: "100%",
                justifyContent: "center",
              }}
            >
              <Button
                variant="text"
                color="error"
                sx={{
                  width: "7rem",
                }}
                onClick={() =>
                  setFilterState({
                    dateFromConfirmation: null,
                    dateToConfirmation: null,
                    dateFromPayment: null,
                    dateToPayment: null,
                    yearOfConfirmation: 2017,
                    paidStatus: "",
                    chamber: "",
                  })
                }
              >
                <Typography fontSize="small">Καθαρισμός</Typography>
              </Button>

              <Button
                variant="outlined"
                sx={{
                  width: "9rem",
                }}
                onClick={handleFilterClick}
              >
                <Typography variant="body2">Αναζήτηση</Typography>
              </Button>
            </Box>
          </LocalizationProvider>
        </FormControl>
      </Box>
    </Box>
  );
};

export default Filter;
